import { getMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const GET_ENTERPRISE = 'GET_ENTERPRISE';
export const GET_ENTERPRISE_SUCCESS = 'GET_ENTERPRISE_SUCCESS';
export const GET_ENTERPRISE_FAILURE = 'GET_ENTERPRISE_FAILURE';

// Action Creators
export const getEnterprise = () => ({
  type: GET_ENTERPRISE,
});

export const getEnterpriseSuccess = (data) => ({
  type: GET_ENTERPRISE_SUCCESS,
  payload: data,
});

export const getEnterpriseFailure = (error) => ({
  type: GET_ENTERPRISE_FAILURE,
  payload: error,
});

// Thunk Function
export const getEnterpriseCallAPI = (data, external) => {
  return async (dispatch) => {
    dispatch(getEnterprise());
    try {
      const response = await getMethodWithToken(url.enterprise + data);
      if (response?.status === 200 || response?.status === 201) {
        dispatch(getEnterpriseSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
      }
    } catch (error) {
      dispatch(getEnterpriseFailure(error?.message));
    }
  };
};
